export function getFlatData(data:any, flattedData: Array<any>){
    return data.map(parent=>{
        if(parent.items.length>0){
            flattedData.push(parent);
            getFlatData(parent.items, flattedData);
        }else{
            flattedData.push(parent);
        }
    });
}



